
import React from 'react';

   // const ApiURl = "http://localhost/EVENT_MANAGER/backend";

    const ApiURl = "https://eventmanager.algo2bots.com/backend";










    export default   ApiURl ;